export enum EnumApiLive {
  Info = '/aliyunlive/savelivepullurl'
}
